module.exports = __webpack_public_path__ + "img/question12.c9878e80.png";